import type { Alert } from '#/graphql/types';
import RecordFieldDefs from '#/types/RecordFieldDefs';

const fields = {
  displayNumber: {
    dataField: 'displayNumber',
    label: 'Display Number',
    dataType: 'string',
  },
  number: {
    dataField: 'number',
    label: 'Number',
    dataType: 'string',
  },
  asset: {
    dataField: 'asset.assetTag',
    label: 'Device Name',
    dataType: 'link',
    valueExpr: 'assetId',
    url: '/assets/:id',
  },
  daysFailed: {
    dataField: 'daysFailed',
    label: 'Days Failed',
    dataType: 'string',
  },
  tisStatus: {
    dataField: 'tisStatus',
    label: 'TIS Status',
    dataType: 'string',
  },
  firstException: {
    dataField: 'firstException',
    label: 'First Exception Date',
    dataType: 'date',
  },
  lastException: {
    dataField: 'lastException',
    label: 'Latest Exception Date',
    dataType: 'date',
  },
  worstException: {
    dataField: 'worstException',
    label: 'Worst Exception Date',
    dataType: 'date',
  },
  impactComfort: {
    dataField: 'impactComfort',
    label: 'Impact Comfort',
    dataType: 'string',
  },
  impactEnergy: {
    dataField: 'impactEnergy',
    label: 'Impact Energy',
    dataType: 'string',
  },
  impactReliability: {
    dataField: 'impactReliability',
    label: 'Impact Reliability',
    dataType: 'string',
  },
  testValue: {
    dataField: 'testValue',
    label: 'Test Value',
    dataType: 'string',
  },
  exceptionName: {
    dataField: 'exceptionName',
    label: 'Exception Name',
    dataType: 'string',
  },
  suggestionCauses: {
    dataField: 'suggestionCauses',
    label: 'Causes',
    dataType: 'list',
    valueExpr: 'name',
  },
  suggestionDescription: {
    dataField: 'suggestionDescription',
    label: 'Suggestion',
    dataType: 'string',
  },
  workOrder: {
    dataField: 'workOrder.displayNumber',
    label: 'Work Order',
    dataType: 'link',
    valueExpr: 'workOrderId',
    url: '/work-orders/:id',
  },
  finding: {
    dataField: 'finding.displayNumber',
    label: 'Finding',
    dataType: 'link',
    valueExpr: 'findingId',
    url: '/findings/:id',
  },
  state: {
    dataField: 'state',
    label: 'Status',
    dataType: 'string',
  },
} satisfies RecordFieldDefs<Alert>;

export default fields;
